import { State } from "@store/types";
import { SurveyRemindersStateProps } from "./types";

export const reminders = (
  state: State
): SurveyRemindersStateProps => state.get("insights_survey_reminders").get("reminders");